import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 mt-3 form-group" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "col-12 form-group"
}
const _hoisted_5 = { class: "col-12 form-group" }
const _hoisted_6 = ["data-maska"]
const _hoisted_7 = { class: "col-12 mt-3" }

import { EOffcanvasPage } from '@/components/Offcanvas/canvas.pages';
import useOffCanvas from '@/components/Offcanvas/useOffCanvas';
import useForm from '@/composables/useForm';
import usePayment from '@/composables/usePayment';
import { IBalancePost } from '@/interfaces';
import { keepOnlyNumbers } from '@/utils';
import { addBalanceValidations } from '@/utils/form_validations';
import { cpfMask, moneyMaskConfig } from '@/utils/masks';
import useVuelidate from '@vuelidate/core';
import { computed, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddBalance',
  setup(__props) {

const values = [30, 50, 100, 150, 200]
const { submitting, addBalance, user_document_number } = usePayment()
const { replaceCanvas } = useOffCanvas()
const { invalidForm } = useForm()

const selected_value = ref<number | "other">(0)
const balance_value = ref('30')
const document_number = ref(user_document_number)

const $v = useVuelidate(addBalanceValidations(), { document_number, balance_value })


const handleSelectedValue = (event: any) => {
  const value = event.target.value as number | 'other'
  if (value == selected_value.value) return
  selected_value.value = value
  if (value == "other") {
    balance_value.value = '0'
  } else {
    balance_value.value = value.toString()
  }
}

const form = computed(() => {
  return {
    document_number: document_number.value,
    value: Number(keepOnlyNumbers(balance_value.value)),
    payment_method: 'pix'
  } as IBalancePost
})

const handleContinue = () => {
  $v.value.$touch()
  if (invalidForm($v.value)) {
    return
  }
  addBalance(form.value, (transactionId) => {
    replaceCanvas(EOffcanvasPage.pix_pending_payment, { props: { transactionId } })
  })
}



return (_ctx: any,_cache: any) => {
  const _component_SubmitBtn = _resolveComponent("SubmitBtn")!
  const _component_AppContainer = _resolveComponent("AppContainer")!
  const _directive_money3 = _resolveDirective("money3")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_AppContainer, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "fw-bold mb-1" }, "Informe o valor que deseja adicionar", -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("label", {
            for: "balance-selection",
            class: "form-label"
          }, "Selecione um valor", -1)),
          _createElementVNode("select", {
            class: "form-select form-control",
            id: "balance-selection",
            onChange: handleSelectedValue
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(values, (value) => {
              return _createElementVNode("option", { value: value }, "R$ " + _toDisplayString(value), 9, _hoisted_3)
            }), 64)),
            _cache[2] || (_cache[2] = _createElementVNode("option", { value: "other" }, "Outro", -1))
          ], 32)
        ]),
        (selected_value.value == 'other')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("label", {
                for: "balane-value-other",
                class: "form-label"
              }, "Informe o valor", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "balane-value-other",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref($v).balance_value.$model) = $event)),
                placeholder: "Informe o valor que deseja adicionar"
              }, null, 512), [
                [
                  _vModelText,
                  _unref($v).balance_value.$model,
                  void 0,
                  { trim: true }
                ],
                [_directive_money3, _unref(moneyMaskConfig)]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            for: "add_credit_card_document",
            class: "form-label"
          }, "CPF", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "data-maska": _unref(cpfMask),
            id: "add_credit_card_document",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref($v).document_number.$model) = $event)),
            placeholder: "999.999.999-99"
          }, null, 8, _hoisted_6), [
            [_directive_maska],
            [
              _vModelText,
              _unref($v).document_number.$model,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_SubmitBtn, {
            title: "Continuar",
            class: "w-100",
            id: "balance-submit-btn",
            loading: _unref(submitting),
            onClick: handleContinue
          }, null, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})